/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOpexDto } from '../../models/backend-opex-dto';
import { BackendOpexRequestDto } from '../../models/backend-opex-request-dto';

export interface SalesOpexsUpdate$Params {
  /**
   * A unique integer value identifying this opex.
   */
  id: number;
  body: BackendOpexRequestDto;
}

export function salesOpexsUpdate(
  http: HttpClient,
  rootUrl: string,
  params: SalesOpexsUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendOpexDto>> {
  const rb = new RequestBuilder(rootUrl, salesOpexsUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendOpexDto>;
    }),
  );
}

salesOpexsUpdate.PATH = '/api/sales/opexs/{id}/';
